import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { getGroupedIssuePosts } from '../../../model/post';
import { Section } from '../index';
import { Intro, Posts } from '../symposium';

const Symposium = ({ issue }) => {
  const {
    tghpwipIssuesTaxonomyFeaturedImage: issueImage,
    tghpwipIssuesTaxonomyFeaturedImageHomeOverride: issueImageHomeOverride,
    tghpwipIssuesTaxonomyColor: themeColor,
    posts: { nodes: issuePosts },
  } = issue;

  const [spotlightPosts, responsePosts, conclusionPosts] = getGroupedIssuePosts(issuePosts);

  const imageAlt = issueImage?.nodes[0]?.altText;
  const imageOverrideAlt = issueImageHomeOverride?.nodes[0]?.altText;

  const image = (
    <>
      {issueImageHomeOverride?.nodes.length > 0 && (
        <GatsbyImage
          image={issueImageHomeOverride?.nodes[0]?.gatsbyImage}
          alt={imageOverrideAlt ? imageOverrideAlt : ''}
        />
      )}
      {issueImageHomeOverride?.nodes.length === 0 && issueImage?.nodes.length > 0 && (
        <GatsbyImage
          image={issueImage?.nodes[0]?.gatsbyImage}
          sizes="(min-width: 720px) 50vw"
          alt={imageAlt ? imageAlt : ''}
        />
      )}
    </>
  );

  return (
    <Section type="symposium" issue={issue} color={themeColor ? themeColor : `black`} panel={true}>
      <div position="beforePanel" className="symposium-issue-grid__image">
        {image}
      </div>
      <Intro position="beforeRestPosts" className="symposium-issue-grid__intro" issue={issue} />
      <Posts
        position="beforeRestPosts"
        className="symposium-issue-grid"
        spotlightPosts={spotlightPosts}
        responsePosts={responsePosts}
        conclusionPosts={conclusionPosts}
      />
    </Section>
  );
};

export default Symposium;
